import axios from "axios";
import { APPLICATION_KEY } from "./Configurations/Urls";

/**
 * Attaches JWT and product key to every axios request.
 * Organization-scoped routes require auth:applicationusers.
 */
export function setupAxiosApplicationKey() {
  axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};

    const token = localStorage.getItem("token");
    if (token && !config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (APPLICATION_KEY && !config.headers["X-Application-Key"]) {
      config.headers["X-Application-Key"] = APPLICATION_KEY;
    }

    return config;
  });
}
